import config from '@/config'
import UserService from '@/service/user'
import * as types from './mutations-type'
import sensors from '@/sensors'

const actions = {
  // 获取登录用户信息
  getLoginUser ({ commit }) {
    return UserService.getLoginUser()
      .then(data => {
        data.avatar = data.avatar || config.defaultAvatar
        commit(types.SETLOGINUSER, data)
        sensors.init()
      })
      .catch(event => {
        console.log('get login error')
        sensors.init()
      })
  }
}

export default actions
